import { Loader2 } from 'lucide-react'

/** Full-screen loading state on the night sky (NightSky is mounted globally in App). */
const Loading = () => (
  <section
    role="status"
    aria-live="polite"
    className="relative flex min-h-screen flex-col items-center justify-center gap-6 px-4"
  >
    <img
      src="/ywc21/logo-compass.webp"
      alt=""
      aria-hidden
      width={488}
      height={319}
      className="h-24 w-auto opacity-90 motion-safe:animate-pulse"
    />
    <div className="flex items-center gap-3 text-ink">
      <Loader2 aria-hidden className="h-5 w-5 motion-safe:animate-spin" strokeWidth={1.5} />
      <span className="text-[16px] font-medium">โปรดรอสักครู่...</span>
    </div>
  </section>
)

export default Loading
